<template>
    <p>
        {{ date }}
    </p>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
        {{ userStore.user.address }}
        <br />
        {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
    </p>
    
    <p>
        {{ creditor.creditor_name }} <br />
        {{ creditor.address_line }} <br />
        {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
    </p>
    <p>
        Re:	Request for student loan information
    </p>
    <div class="page">
        <p>
            To {{ creditor.creditor_name }}:
        </p>
        <p class="letter-content">
            My name is {{ userStore.user.firstname }} {{ userStore.user.lastname }}. My date of birth is {{ userStore.user.dob }}. My social security number is {{ userStore.user.ssn }}. You are listed as a student loan servicer or lender on credit reports about me. You have reported various account information data related to the alleged loans concerning me. Note I do not agree with the various account information related that you are reporting about me.  Assist me in the verification of the alleged student loans you are collecting and your legal status. Please send me a copy of all promissory notes of all student loans that you service related to me. Please send me a copy of the promissory note for any and all student loans that you originated. Please send me a copy of any assignments of the promissory notes for the related student loans. Please advise me whether you are the loan originator, servicer, and/or debt collector for the loans. Kindly provide this information to me in writing by mailing it to my address above within 30 days. Out of an abundance of caution cease and desist any and all credit reporting of the related accounts.
        </p>
        <p class="letter-content">
            Sincerely, <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        },
    };
</script>
